<template>
  <v-main>
    <!--LAPTOP-->
    <v-container class="hidden-md-and-down">
      <div class="centered">
        <v-btn v-if="showEdit" style="width:10px" text @click="goBack()">
          <v-icon>mdi-chevron-left</v-icon>
          Back
        </v-btn>
        <v-row>
          <v-col>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-three-line"
            ></v-skeleton-loader>
            <!-- <div width="10px">
           <v-row>
            <v-col v-for="n in 3" :key="n">
              <v-skeleton-loader
                class="mb-6 mt-6"
                type="avatar"
                
              ></v-skeleton-loader>
            </v-col>
          </v-row>
          </div> -->

            <h1 class="animate__animated animate__fadeInDown">
              {{ userData.name }}
            </h1>
            <p style="width:80%" class="animate__animated animate__fadeInDown">
              {{ userData.bio }}
            </p>
            <v-btn
              @click="editBio = !editBio"
              fab
              x-small
              style="margin-top:-10px"
              v-if="showEdit"
              ><v-icon>mdi-pen</v-icon></v-btn
            >
            <div
              style="margin-top:19px"
              v-if="!loading"
              class="animate__animated animate__fadeInDown"
            >
              <v-btn
                v-if="userData.facebook != ''"
                target="_blank"
                style="margin-right:10px"
                x-small
                depressed
                fab
                :href="`https://facebook.com/${userData.facebook}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-facebook
                </v-icon>
              </v-btn>

              <v-btn
                v-if="userData.twitter != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://twitter.com/${userData.twitter}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-twitter
                </v-icon>
              </v-btn>

              <v-btn
                v-if="userData.instagram != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://instagram.com/${userData.instagram}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-instagram
                </v-icon>
              </v-btn>

              <v-btn
                v-if="userData.linkedin != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://linkedin.com/${userData.linkedin}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-linkedin
                </v-icon>
              </v-btn>

              <v-btn
                v-if="userData.youtube != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://youtube.com/${userData.youtube}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-youtube
                </v-icon>
              </v-btn>

              <v-btn
                v-if="userData.tiktok != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://tiktok.com/${userData.tiktok}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-music-note
                </v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col>
            <v-avatar size="130px">
              <v-img :src="image" :lazy-src="image" />
            </v-avatar>
            <v-btn
              @click="imageModal()"
              :loading="imgloading"
              v-if="showEdit"
              small
              fab
              ><v-icon>mdi-pen</v-icon></v-btn
            >
            <input
              type="file"
              @change="onFileChanged"
              accept="image/png, image/jpeg,image/gif"
              hidden
              ref="imageUpload"
            />
          </v-col>
        </v-row>
        <div v-if="showTip" class="d-flex" style="margin-top:40px">
          <v-btn
            width="400px"
            x-large
            rounded
            @click="tipModal = !tipModal"
            :color="userData.btncolor"
            :style="{ color: userData.bg }"
            class="mr-5"
            >Tip {{ userData.name.split(" ")[0] }}
          </v-btn>

           <v-btn
            width="190px"
            class="animate__animated animate__fadeInLeft animate__delay-1s"
            x-large
            rounded
            outlined
            @click="subscribeModal = !subscribeModal"
            :color="userData.btncolor"
            
            ><v-icon class="mr-2">mdi-email-outline</v-icon>Subscribe
          </v-btn>

        </div>
      </div>
    </v-container>

    <!--Phone-->
    <div
      class="hidden-lg-and-up text-center"
      style="margin:15px auto auto auto;width:100%"
    >
     <v-btn v-if="showEdit" style="text-align:start" text @click="goBack()">
          <v-icon>mdi-chevron-left</v-icon>
          Back
        </v-btn>
      <v-container style="text-align:center">
        <v-btn
          v-if="loading"
          style="width:80px;margin:auto"
          width="80px"
          depressed
          text
          height="80px"
          fab
        >
        </v-btn>
        <v-avatar
          class="animate__animated animate__fadeInDown"
          size="80px"
          style="margin:auto"
        >
          <v-img :src="image" :lazy-src="image" />
        </v-avatar>
        <v-btn
          @click="imageModal()"
          :loading="imgloading"
          v-if="showEdit"
          style="margin-top:50px;margin-left:-40px"
          x-small
          fab
          ><v-icon>mdi-pen</v-icon></v-btn
        >

        <h2
          class="animate__animated animate__fadeInDown"
          style="text-align:center"
        >
          {{ userData.name }}
        </h2>
        <p
          class="animate__animated animate__fadeInDown"
          style="text-align:center;font-size:14px"
        >
          {{ userData.bio }}
        </p>
        <v-btn
              @click="editBio = !editBio"
              fab
              x-small
              style="margin-top:-10px"
                v-if="showEdit"
              ><v-icon>mdi-pen</v-icon></v-btn
            >
        <div
          class="animate__animated animate__fadeInDown"
          v-if="!loading"
          style="margin-top:19px"
        >
          <v-btn
            v-if="userData.facebook != ''"
            target="_blank"
            style="margin-right:10px"
            x-small
            depressed
            fab
            :href="`https://facebook.com/${userData.facebook}`"
            :color="userData.btncolor"
          >
            <v-icon :color="userData.bg">
              mdi-facebook
            </v-icon>
          </v-btn>

          <v-btn
            v-if="userData.twitter != ''"
            target="_blank"
            x-small
            style="margin-right:10px"
            depressed
            fab
            :href="`https://twitter.com/${userData.twitter}`"
            :color="userData.btncolor"
          >
            <v-icon :color="userData.bg">
              mdi-twitter
            </v-icon>
          </v-btn>

          <v-btn
            v-if="userData.instagram != ''"
            target="_blank"
            x-small
            style="margin-right:10px"
            depressed
            fab
            :href="`https://instagram.com/${userData.instagram}`"
            :color="userData.btncolor"
          >
            <v-icon :color="userData.bg">
              mdi-instagram
            </v-icon>
          </v-btn>

           <v-btn
                v-if="userData.linkedin != ''"
                target="_blank"
                x-small
                style="margin-right:10px"
                depressed
                fab
                :href="`https://instagram.com/${userData.linkedin}`"
                :color="userData.btncolor"
              >
                <v-icon :color="userData.bg">
                  mdi-linkedin
                </v-icon>
              </v-btn>

          <v-btn
            v-if="userData.youtube != ''"
            target="_blank"
            x-small
            style="margin-right:10px"
            depressed
            fab
            :href="`https://youtube.com/${userData.youtube}`"
            :color="userData.btncolor"
          >
            <v-icon :color="userData.bg">
              mdi-youtube
            </v-icon>
          </v-btn>

          <v-btn
            v-if="userData.tiktok != ''"
            target="_blank"
            x-small
            style="margin-right:10px"
            depressed
            fab
            :href="`https://tiktok.com/${userData.tiktok}`"
            :color="userData.btncolor"
          >
            <v-icon :color="userData.bg">
              mdi-music-note
            </v-icon>
          </v-btn>
        </div>
        <div v-if="showTip" style="margin-top:30px;padding:0px 10px 0px 10px">
          <v-btn
            x-large
            rounded
            @click="tipModal = !tipModal"
            :color="userData.btncolor"
            :style="{ color: userData.bg }"
             style="max-width:190px;width:190px"
             class="mr-2"
            >Tip {{ userData.name.split(" ")[0] }}
           
          </v-btn>
           
           <v-btn
            width="160px"
            class="mt-2 animate__animated animate__fadeInLeft"
            x-large
            rounded
            outlined
            @click="subscribeModal = !subscribeModal"
            :color="userData.btncolor"
            
            ><v-icon class="mr-2">mdi-email-outline</v-icon>Subscribe
          </v-btn>
        </div>
      </v-container>
    </div>

    <v-dialog fullscreen v-model="editBio" scrollable >
      <v-sheet height="130%">
        <div style="width:80%;margin:26px auto auto auto"> 
        <v-btn small fab depressed @click="editBio = !editBio"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <v-textarea
          :color="userData.btncolor"
          outlined
          class="mt-4"
          v-model="userData.bio"
        />
        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          v-model="userData.facebook"
          style="height:60px;border-radius:12px"
          prefix="https://facebook.com/"
          prepend-inner-icon="mdi-facebook"
        />

        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          style="height:60px;border-radius:12px"
          v-model="userData.twitter"
          prefix="https://twitter.com/"
          prepend-inner-icon="mdi-twitter"
        />

        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          style="height:60px;border-radius:12px"
          v-model="userData.instagram"
          prefix="https://instagram.com/"
          prepend-inner-icon="mdi-instagram"
        />

        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          style="height:60px;border-radius:12px"
          v-model="userData.linkedin"
          prefix="https://linkedin.com/"
          prepend-inner-icon="mdi-linkedin"
        />

        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          style="height:60px;border-radius:12px"
          v-model="userData.youtube"
          prefix="https://youtube.com/"
          prepend-inner-icon="mdi-youtube"
        />

        <v-text-field
          :color="userData.btncolor"
          outlined
          class="mt-4"
          style="border-radius:12px"
          v-model="userData.tiktok"
          prefix="https://tiktok.com/"
          prepend-inner-icon="mdi-music-note"
        />


        <v-btn
          @click="updateBio()"
          x-large
          style="border-radius:12px;margin-bottom:20px"
          block
          :color="userData.btncolor"
          :style="{ color: userData.bg }"
          :loading="btnloading"
          >Update Bio</v-btn
        >
        </div>
      </v-sheet>
    </v-dialog>

    <v-bottom-sheet v-model="tipModal">
      <div style="text-align:center;margin:0px 0px 10px 0px">
        <v-avatar size="70px" style="margin:auto auto -30px auto">
          <v-img :src="image" :lazy-src="image" />
        </v-avatar>
      </div>
      <v-sheet
        style="border-radius:30px 30px 0px 0px;padding:30px 10% 60px 10%"
        height="430px"
      >
        <p style="font-size:19px" class="font-weight-bold text-center">
          Make
          <span :style="{ color: userData.btncolor }"
            >{{ userData.name.split(" ")[0] }}</span
          >
          happy with a Tip.
        </p>
        <v-text-field
          @keyup="setName()"
          outlined
          :color="userData.btncolor"
          style="margin:auto;max-width:600px;height:69px;border-radius:14px"
          v-model="name"
          label="What's your name"
        />
        <v-text-field
          @keyup="setEmail()"
          outlined
          :color="userData.btncolor"
          style="margin:auto;max-width:600px;height:69px;border-radius:14px"
          v-model="email"
          label="What's your email"
        />
        <v-text-field
          type="number"
          outlined
          :color="userData.btncolor"
          style="margin:auto;max-width:600px;height:69px;border-radius:14px"
          v-model="amount"
          label="Amount"
          :prefix="userData.currency"
        />
        <Flutterwave
          :userData="userData"
          :email="email"
          :amount="amount"
          :is-production="isProduction"
          :name="name"
          :reference="referenceFlutter"
          flw-key="FLWPUBK-dbe851d7b426b96d183b36373de5959f-X"
          :callback="callbackFlutter"
          :close="close"
          :currency="userData.currency"
          :country="country"
          :payment_method="paymentMethod"
          :logo="userData.photoURL"
          class="animate__animated animate__fadeInUp"
          style="margin:auto;max-width:600px;"
        />
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="subscribeModal">
      <div style="text-align:center;margin:0px 0px 10px 0px">
        <v-avatar size="70px" style="margin:auto auto -30px auto">
          <v-img :src="image" :lazy-src="image" />
        </v-avatar>
      </div>
      <v-sheet
        style="border-radius:30px 30px 0px 0px;padding:30px 10% 60px 10%"
        height="430px"
      >
        <p style="font-size:19px" class="font-weight-bold text-center">
          Subscribe to
          <span :style="{ color: userData.btncolor }"
            >{{ userData.name.split(" ")[0] }}'s</span
          >
          Newsletters
        </p>
        <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="mb-4"
  >
        <v-text-field
          @keyup="setName()"
          outlined
          :color="userData.btncolor"
          style="margin:auto;max-width:600px;height:69px;border-radius:14px"
          v-model="name"
          label="What's your name"
          required
        />
        <v-text-field
          @keyup="setEmail()"
          outlined
          :color="userData.btncolor"
          style="margin:auto;max-width:600px;height:69px;border-radius:14px"
          v-model="email"
           :rules="emailRules"
         required
          label="What's your email"
        />
        </v-form>
      <div class="flw"  style="margin:auto;max-width:600px;">
    <v-btn :color="userData.btncolor" 
    :loading="btnloading"
    :style="{color:userData.bg}" 
    class="animate__animated animate__fadeInUp"
    style="border-radius:15px;margin:auto;max-width:600px;" block x-large  @click="subscribeUser">
      Subscribe
    </v-btn>
  </div>
      </v-sheet>
    </v-bottom-sheet>


    <v-dialog fullscreen v-model="successfulTip">
      <v-sheet color="#22ad80" height="100%" style="padding-top:19%" class="white--text text-center">
        <v-btn color="#198763" fab x-large depressed>
          <v-icon color="white">mdi-cash-multiple</v-icon>
        </v-btn>
         <h1>Payment Successful</h1>
         <p>You just successfully sent {{amount}} to <b>{{userData.name}}</b> </p>
         <v-btn @click="successfulTip =! successfulTip" style="border-radius:15px;color:#22ad80" width="200px" x-large color="white">Done </v-btn>
      </v-sheet>
    </v-dialog>
  </v-main>
</template>

<script>
import Flutterwave from "./FlutterwaveModal.vue";
import moment from "moment";
import { doc, updateDoc, arrayUnion,increment } from "firebase/firestore";
import db from "@/db";
import axios from "axios";

export default {
  components: {
    Flutterwave
  },
  props: {
    userData: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    image: {
      type: String
    },
    imgloading: {
      type: Boolean
    }
  },
  data: () => ({
    tipModal: false,
    subscribeModal:false,
    amount: "",
    email: "",
    name: "",
    flutterwaveRef: "",
    flwKey: "FLWPUBK-dbe851d7b426b96d183b36373de5959f-X",
    showTip: true,
    subscriberpayLoad: "",
    notificationsPayLoad: "",
    transactionPayload: "",
    paymentMethod: "",
    isProduction: true,
    country: "",
    showEdit: false,
    picture: "",
    imageData: "",
    editBio: false,
    snackbar: false,
    error: "",
    btnloading:false,
    successfulTip:false,
    valid:true,
     emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ]
  }),

  computed: {
    referenceFlutter() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    }
  },

  watch: {
    flutterwaveRef() {
      this.changesInDatabase();
    }
  },

  created() {
    if (this.$route.params.id == localStorage.getItem("tippingsKey")) {
      this.showEdit = true;
    }

    this.name = localStorage.getItem("name");
    this.email = localStorage.getItem("email");
    if (this.$route.params.id == localStorage.getItem("tippingsKey")) {
      this.showTip = false;
    }
  },

  methods: {

    goBack(){
      this.$router.go(-1)
    },
  
    async updateBio() {
      this.btnloading = true
      await updateDoc(doc(db, "users", localStorage.getItem("tippingsKey")), {
        bio: this.userData.bio,
        facebook:this.userData.facebook,
        twitter:this.userData.twitter,
        instagram:this.userData.instagram,
        linkedin:this.userData.linkedin,
        youtube:this.userData.youtube,
        tiktok:this.userData.tiktok
      });
      this.btnloading = false;
      this.$swal({
        title: "Profile updated successfully!",
        text: "Good job!. You've successfully updated your profile!",
        icon: "success",
        confirmButtonText: "Yay!",
      })

    },

    imageModal() {
      this.$refs.imageUpload.click();
    },

    onFileChanged(event) {
      this.$emit("onFileChanged", event, this.$refs.imageUpload.files[0]);
    },

    setName() {
      localStorage.setItem("name", this.name);
    },

    setEmail() {
      localStorage.setItem("email", this.email);
    },

    async changesInDatabase() {
      this.subscriberpayLoad = {
        name: this.name,
        email: this.email,
        amount: this.amount
      };
      this.transactionPayload = {
        name: this.name,
        email: this.email,
        fullname: this.name,
        title: "Tip payment",
        status: "successful",
        amount: `${parseFloat(this.amount)}`,
        timestamp: moment(Date.now()).format("LLL"),
        image: "https://i.ibb.co/8mRPfhc/credit-card-2.png"
      };

      (this.notificationsPayLoad = {
        title: "Tip received!",
        message: "You received a tip from " + this.name,
        timestamp: moment(Date.now()).format("LLL")
      }),
        await updateDoc(doc(db, "users", this.$route.params.id), {
          transactions: arrayUnion(this.transactionPayload),
          notifications: arrayUnion(this.notificationsPayLoad),
          subscribers: arrayUnion(this.subscriberpayLoad),
          wallet: increment(parseFloat(this.amount))
        });
      this.successfulTip = true
      axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/mail",
        data: {
          from: `${this.userData.name} <support@tippings.me>`,
          email: this.userData.email,
          replyTo: this.userData.email,
          title: "You just received a tip from, " + this.name,
          message: `<h2>Congratulations, ${this.userData.name}</h2> <p> <b>${this.name}</b> just sent you <b>${this.amount}</b> on Tippings</p><p>You can now instantly withdraw your funds to your bank account.</p> <p>If you need customer support, send an email to <a href="support@tippings.me">support@tippings.me</a>`
        }
      }).then(response => {
        console.log(response);
      });
    },

    makePayment() {
      window.FlutterwaveCheckout({
        public_key: this.flwKey,
        tx_ref: this.reference,
        amount: this.amount,
        currency: this.currency,
        payment_options: this.payment_method,
        customer: {
          name: this.name,
          email: this.email
        },
        callback: response => this.callback(response),
        customizations: {
          title: this.custom_title,
          description: "Payment for items in cart",
          logo: this.custom_logo
        }
      });
    },

    close: () => {
      console.log("You closed checkout page");
      this.error = "You closed checkout page";
      this.snackbar = true;
    },

    callbackFlutter(response) {
      this.flutterwaveRef = response.referenceFlutter;
    },


    async subscribeUser() {
      this.btnloading = true
    if(this.name == null || this.email == null || this.valid == false){
       this.$swal({
        title: "You need to enter your name/email",
        text: "Please enter your name and a valid email to subscribe to the email list",
        icon: "error",
        confirmButtonText: "Ok",
      })
      this.btnloading = false
    } 

    else{
      axios({
        method:"POST",
        url:"https://tips-api.herokuapp.com/subscribe",
        data:{
          name:this.name,
          email:this.email,
          userData:this.userData,
          userSlug:this.$route.params.id
        }
      })
     .then(response => {
        console.log(response);
        this.btnloading = false
         this.$swal({
        title: "Subscription Successful!",
        text: "Congratulations!. You have successfully subscribed to " + this.userData.name+"'s Newsletter",
        icon: "success",
        confirmButtonText: "Ok",
      })
      }).catch(()=>{
         this.btnloading = false
         this.$swal({
        title: "Something's wrong!",
        text: "Subscription was not successful. Please try again",
        icon: "error",
        confirmButtonText: "Try again",
      })
      })
    }
    }
  }
};
</script>

<style>
.centered {
  width: 1000px;
  margin: 2% 22% 0px 22%;
}
</style>

<style lang="sass">
@import '../sass/variable.scss'
</style>
